// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8AY7Q","colBig":"styles_colBig__3dfgI","colSmall":"styles_colSmall__3GRuS"};